export const generalKey = 'product_e7_p2s';
export const whiteLocaleList = ['us'];
export const productPageUrl = 'ocean-pro-home-solar-battery';

export const oceanProConsultationUrl = `https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage`;
